import api from './../../service/api';
import routes from "../../service/apiRoutes";


export const createAccount = (data) => api.post(routes.createAccount, data, {noauth: true})